import axiosapi from "./axiosAPI";

// Get All Wards
export const getAllWards = async (
    setWards,
    setFetcherror,
    setIsLoading
    
) => {
    
    
	try{
		const res =await axiosapi.get("/wards");
        setWards(res.data.data ? res.data.data : {});
        setIsLoading(false);

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Wards");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Wards");
		}
		
	}
	
};

// Get All Wards per District
export const getDistrictWards = async (
    setWards,
    setFetcherror,
    pkid
) => {
    
    
	try{
		const res =await axiosapi.get(`/districtwards/${pkid}`);
        setWards(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Wards");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Wards");
		}
		
	}
	
};



// Get One Ward
export const getOneWard = async (
    pkid,
    setFetcherror,  
    setWard
    
)=>{
	try{
		const res =await axiosapi.get(`/wards/${pkid}`);
        setWard(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Ward");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Ward");
		}
		
	}
	
};


// Create New Ward
export const createWard = async (
    ward,
    district_id,
    setWard,
    setFetcherror,
    handleAllToasts,
    setWards,
    setIsLoading

) => {


    if (!ward ) {
        handleAllToasts(2, "No Ward Provided"); 
            return; 
        }

    const PushItem = {
        name: ward,
        district_id:district_id
        };

    try{
        await axiosapi.post("/wards/",PushItem );
        setWard("");
        handleAllToasts(1, "Ward Created Successfully");
        getAllWards(setWards,setFetcherror,setIsLoading);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Ward");
            handleAllToasts(2, "Could Not update The Ward");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Ward");
            handleAllToasts(2, "Could Not update The Ward");
            
        }
        
    }
    
}


// Edit Existing Ward

export const editWard = async (
    wardpkid,
    editedWard,
    setEditedWard,
    selecetedEditedDistrict,
    setSelectedEditedDistrict,
    setFetcherror,
    handleAllToasts,
    setWards,
    setIsLoading
    
              
        ) => {

            if (!editedWard) {
                handleAllToasts(2, "No Ward Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:wardpkid,
                    name: editedWard,
                    district_id:selecetedEditedDistrict?.id
                };

            try{
                await axiosapi.patch("/wards/",PushItem );
                setEditedWard("");
                setSelectedEditedDistrict("");
                handleAllToasts(1, "Ward Updated Successfully");
                getAllWards(setWards,setFetcherror,setIsLoading);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Ward");
                    handleAllToasts(2, "Could Not Update Ward");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Ward");
                    handleAllToasts(2, "Could Not Update Ward");
                    
                }
                
            }
            
};



// Delete Existing Ward.

export const deleteWard = async (
    wardpkid,
    setcountries,
    setFetcherror,
    handleAllToasts,
    setIsLoading
)=>{
    try {
        const res = await axiosapi.delete(`/wards/${wardpkid}`);
        let finalData = res.data.message;
        getAllWards(setcountries, setFetcherror,setIsLoading);
        handleAllToasts(1, "Ward Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Ward");
            handleAllToasts(2,"Error: Could Not Delete Ward");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Ward");
            handleAllToasts(2,"Error: Could Not Delete Ward");
		}
		
	}
	
};